<template>
  <div>
    <!--begin::Dashboard-->
    <div class="row" v-if="isSuperAdmin || isCustomer || isTechnician || isOperator">
      <div class="col-12">
        <div class="card text-center mb-1">
          <div
            class="
              card-body
              py-1
              d-flex
              align-items-center
              justify-content-between
              m-0
            "
          >
            <div class="right col-9 text-left">
              <div class="text-muted line-ellipsis h4">{{$t("dashboard.service_information")}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 col-12">
        <ServiceTypesWidget></ServiceTypesWidget>
      </div>
      <div class="col-xl-8 col-12">
        <ServiceStatusWidget></ServiceStatusWidget>
      </div>
      <div class="col-12 dashboard-latest-update">
        <ServiceHistoryWidget
          @historyData="emitHistoryData($event)"
        ></ServiceHistoryWidget>
      </div>
      <div class="col-12">
        <DashboardServicesMaps :historyData="historyData" ></DashboardServicesMaps>
      </div>


      <div class="col-12" v-if="isSuperAdmin || isCustomer">
        <div class="card text-center mb-1">
          <div
            class="
              card-body
              py-1
              d-flex
              align-items-center
              justify-content-between
              m-0
            "
          >
            <div class="right col-9 text-left">
              <div class="text-muted line-ellipsis h4">{{$t("dashboard.institution_informations")}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12">
        <InstitutionWidget v-if="isSuperAdmin || isCustomer"></InstitutionWidget>
      </div>
      <div class="col-12">
        <DashboardInstitutionBranchMap v-if="isSuperAdmin || isCustomer"></DashboardInstitutionBranchMap>
      </div>
      <div class="col-12" v-if="isSuperAdmin">
        <div class="card text-center mb-1">
          <div
            class="
              card-body
              py-1
              d-flex
              align-items-center
              justify-content-between
              m-0
            "
          >
            <div class="right col-9 text-left">
              <div class="text-muted line-ellipsis h4">{{$t("dashboard.user_informations")}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <UserInformationWidget  v-if="isSuperAdmin"></UserInformationWidget>
      </div>
      <div class="col-12 p-0">
        <DashboardUsersMap v-if="isSuperAdmin"></DashboardUsersMap>
      </div>
    </div>
    <div class="row" v-if="isStore">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5>Hoş Geldiniz...</h5>
          </div>
        </div>
      </div>
    </div>
    
    <!--end::Dashboard-->
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import UserWidget from "@/view/content/widgets/mixed/UserWidget.vue";
import InstitutionWidget from "@/view/content/widgets/mixed/InstitutionWidget.vue";
import ServiceWidget from "@/view/content/widgets/mixed/ServiceWidget.vue";
import TopOperatorWidget from "@/view/content/widgets/list/TopOperatorWidget.vue";
import ServiceStatusWidget from "@/view/content/widgets/mixed/ServiceStatusWidget.vue";
import ServiceHistoryWidget from "@/view/content/widgets/mixed/ServiceHistoryWidget.vue";
import ServiceTypesWidget from "@/view/content/widgets/list/ServiceTypesWidget.vue";
import DashboardServicesMaps from "@/view/content/maps/DashboardServicesMaps.vue";
import DashboardInstitutionBranchMap from "@/view/content/maps/DashboardInstitutionBranchMap.vue";
import DashboardUsersMap from "@/view/content/maps/DashboardUsersMap.vue";
import UserInformationWidget from "../content/widgets/mixed/UserInformationWidget.vue";
export default {
  name: "dashboard",
  components: {
    UserWidget,
    InstitutionWidget,
    ServiceWidget,
    TopOperatorWidget,
    ServiceStatusWidget,
    ServiceTypesWidget,
    ServiceHistoryWidget,
    DashboardServicesMaps,
    DashboardInstitutionBranchMap,
    DashboardUsersMap,
    UserInformationWidget,
  },
  data() {
    return {
      historyData: [],
      institutions: [
        {
          id: 0,
          name: "Limonist Medya",
        },
        {
          id: 1,
          name: "Ahmet Medya 1",
        },
        {
          id: 2,
          name: "Alparslan Medya 2",
        },
      ],
      roles: [
        {
          id: 1,
          name: "Saha Personeli",
        },
        {
          id: 2,
          name: "Depo Kullanıcı",
        },
        {
          id: 3,
          name: "Operatör",
        },
        {
          id: 4,
          name: "Kurumsal Kullanıcı",
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
  },
  methods: {
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    emitHistoryData(e) {
      this.historyData = [];
      this.historyData = e;
      this.historyData = e;
    },
    setActiveTab1(event) {
      this.tabIndex = this.setActiveTab(event);
    },
    setActiveTab2(event) {
      this.tabIndex2 = this.setActiveTab(event);
    },
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      // get all tab links
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set current active tab
      event.target.classList.add("active");

      // set clicked tab index to bootstrap tab
      return parseInt(event.target.getAttribute("data-tab"));
    },
  },
};
</script>
<style scoped>

</style>
